/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1717
 */

"use strict"

var r = require(/* 86 */"./1650/86/index")
var /* [auto-meaningful-name] */require_1275_$_1716_1275$start = require(/* 1275 */"./1716/1275").start
r({
  target: "String",
  proto: true,
  forced: require(/* 1276 */"./1716/1276")
}, {
  padStart: function (e) {
    return require_1275_$_1716_1275$start(this, e, arguments.length > 1 ? arguments[1] : undefined)
  }
})
